module.exports = __webpack_public_path__ + "img/Home_Finding_Logo.6b54b8bf.png";